export type ValidatableRef<T> = T & { validate: () => boolean };
export const isValidatableRef = (
  ref: Record<string, unknown> | Element | Vue | Element[] | Vue[]
): ref is ValidatableRef<Vue> =>
  ref !== undefined && !Array.isArray(ref) && "validate" in ref && typeof ref.validate === "function";
export const getValidatableRef = (ref: Record<string, unknown> | Element | Vue | Element[] | Vue[]) =>
  isValidatableRef(ref) ? ref : undefined;
